import { render } from "./advisorTokenAdviceContent.vue?vue&type=template&id=2759d66d&scoped=true&ts=true"
import script from "./advisorTokenAdviceContent.vue?vue&type=script&lang=ts"
export * from "./advisorTokenAdviceContent.vue?vue&type=script&lang=ts"

import "./advisorTokenAdviceContent.vue?vue&type=style&index=0&id=2759d66d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2759d66d"]])

export default __exports__